import { render } from "./buynow.vue?vue&type=template&id=14e2b489"
import script from "./buynow.vue?vue&type=script&lang=js"
export * from "./buynow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__